/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-18 16:11:18 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-14 09:29:06
 */
import client from './client';

export default {
  getList: (data) => {
    data = data || {};

    return client.get('advertiser/console/list?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  getSuggestionList: data => {
    return client.get('advertiser/suggestion/list?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  delete: (id) => {
    return client.delete('advertiser/delete/' + id).then(res => res.data);
  },
  // 获取商家详情
  getDetail: (id) => {
    return client.get('advertiser/detail?id=' + id).then(res => res.data);
  },
  // 获取联盟列表
  getAffiliateList: () => {
    return client.get('advertiser/dict/affiliate/list').then(res => res.data);
  },
  // 获取分类列表
  getCategoryList: () => {
    return client.get('advertiser/dict/category/list').then(res => res.data);
  },
  // 获取region列表
  getRegionList: () => {
    return client.get('advertiser/dict/region/list').then(res => res.data);
  },
  getAffiliateRegionList: () => {
    return client.get('advertiser/dict/affiliate/region/list').then(res => res.data);
  },
  // 获取AM IM列表
  getAssignedAMIMList: () => {
    return client.get('advertiser/dict/assigned/editor/list').then(res => res.data);
  },
  getLogList: (data) => {
    return client.get('advertiser/log/list?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  // 搜索白名单
  getKolWhiteList: (keyword = '', size = 20) => {
    if (!(size > 0)) {
      size = 20;
    }
    return client.get('user/list/by-userName?userName=' + keyword).then(res => res.data);
  },
  getSettingsInfo: () => {
    return client.get('advertiser/dict/cpa/settings/info').then(res => res.data);
  },
  addAdvertiser: (data) => {
    return client.post('advertiser/submit', data).then(res => res.data);
  },
  getAffiliateListById:(id) => {
    return client.get('advertiser/affiliate/list?advertiserId='+ id).then(res => res.data);
  },
  addAffiliate: (data) => {
    return client.post('advertiser/affiliate/submit', data).then(res => res.data);
  },
  deleteAffiliate: (id) => {
    return client.delete(`advertiser/affiliate/delete/${id}`).then(res => res.data);
  },
  // 商家提成明细列表, mock: http://116.62.11.65:8080/~m/#/apps/595/api/6/group/131?_k=fnokss
  commissionDetail: relationId => {
    return client.get(`advertiser/commission/detail?advertiserAffiliateRelationId=${relationId}`).then(res => res.data);
  },
  // 获取商家名
  getAdvertiserName: id => {
    return client.get(`advertiser/info?id=${id}`).then(res => res.data);
  },
  // url convert
  convertLink: (data) => {
    return client.post('advertiser/convert/link', data).then(res => res.data);
  },
  convertOfficialLink: (data) => {
    return client.post('advertiser/official/convert/link', data).then(res => res.data);
  },
  // 图片上传
  uploadImg: data => {
    if (data.file) {
      return client.put('https://thumbimg.inrewards.com/api/storage/v2/file/a.jpg?biz=inrewards', data.file).then(res => res.data);
    } else {
      return client.put(`https://thumbimg.inrewards.com/api/storage/v2/file/${data.url}?biz=inrewards`).then(res => res.data);
    }
  },
  //流量分配配置：开关 + 各联盟当前比列
  getTrafficAllocationConfig: (advertiserId) => {
    return client.get(`advertiser/traffic/config?advertiserId=${advertiserId}`).then(res => res.data);
  },
  toggleTrafficAllocation: (data) => {
    return client.post('advertiser/traffic/toggle', data).then(res => res.data);
  },
  saveTrafficAllocation: (data) => {
    return client.post('advertiser/traffic/save', data).then(res => res.data);
  },
}
